export default __webpack_public_path__ + "static/media/grafema_illustrations-ua-campaign_02.5753aa27.jpg";